import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../../../theme'

const deviceWidth = Dimensions.get('window').width

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        margin: 12,
        alignItems: 'center',
    },
    input: {
        fontSize: 15,
        width: deviceWidth - 30,
        height: 40,
        marginTop: 0,
        marginBottom: 5,
        marginHorizontal: 15,
        borderWidth: StyleSheet.hairlineWidth,
        borderRadius: 5,
        borderColor: theme.colors.lightGray,
        padding: 10,
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingHorizontal: 15,
        paddingTop: 5,
        paddingBottom: 8,
    },
    auditor: {
        fontSize: 16,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingHorizontal: 0,
        paddingBottom: 8,
    },
    date: {
        fontSize: 15,
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingHorizontal: 0,
    },
    percentage: {
        fontSize: 19,
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
    },
    percentageCircle: {
        fontSize: 16,
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
})

export default styles
